export default __webpack_public_path__ + "assets/youtubeShareLink.ab2879ef.gif";